import {useState} from "react";
import {Col, Form} from "react-bootstrap";
import {useSelector} from "react-redux";
import FormField from "../FormField";
import ListField from "./ListField";

const FieldGroupNotExpanded = ({setExpanded, title, fieldnames, props}) => {
  const textbausteine = useSelector(st => st.textbausteine);
  const {variables} = props;
  const [first, second] = fieldnames;

  const tbArr1 = variables[second] ? variables[second].split(" ").map(i => parseInt(i)) : [];
  const tbArr2 = tbArr1.map(id => textbausteine.find(tb => tb.id === id));
  // console.log({ tbArr2 });
  const displayedTxt = tbArr2.map(tb => <p key={tb.id}>{tb.text}</p>);
  const punkteTxt = variables[first] ? `(Punkte: ${variables[first]})` : "";
  const borderColor = variables[first] && variables[second] ? "green" : "darkred";
  return (
    <div
      className="p-3 my-1"
      style={{border: `2px solid ${borderColor}`, borderRadius: "5px"}}
      onClick={() => setExpanded(true)}
      column-count="1"
    >
      <Form.Row>
        <h5>
          {title} {punkteTxt}
        </h5>
      </Form.Row>
      {displayedTxt}
    </div>
  );
};

const FieldGroup = ({fieldnames, props, title}) => {
  const [expanded, setExpanded] = useState(false);
  const [first, second, third] = fieldnames;
  const {variables, fieldSettings, setVariables} = props;
  if (!(fieldSettings[first] && fieldSettings[second] && fieldSettings[third])) return null;
  if (!expanded) return <FieldGroupNotExpanded setExpanded={setExpanded} title={title} fieldnames={fieldnames} props={props} />;
  return (
    <div className="p-3 my-1" style={{border: "1px solid grey", borderRadius: "5px"}}>
      <Form.Row>
        <h5 onClick={() => setExpanded(false)}>{title} </h5>
      </Form.Row>
      <Form.Row>
        <Col>
          <ListField name={second} setVariables={setVariables} variables={variables} first={first} second={second}></ListField>
          <FormField props={{...props, name: first}} />
          <FormField props={{...props, name: third}} />
        </Col>
      </Form.Row>
      <button className="btn btn-outline-dark" onClick={() => setExpanded(false)}>{`Ok, Abschnitt "${title}" schließen und weiter`}</button>
    </div>
  );
};
export default FieldGroup;
